import { StandaloneComponent } from '@/types/component';
import getConfig from 'modules/config';
import Script from 'next/script';
import { useEffect } from 'react';

export const StandaloneConsent: StandaloneComponent = () => {
  const consentVersion = `2.3.14${
    ['svenskdam', 'hant'].includes(`${process.env.OCELOT_SITE}`) ? `${process.env.OCELOT_SITE}` : ''
  }`;
  const consentPath = `/common/js/consent`;
  const componentVersion = '03';
  const cacheBuster = `v=${consentVersion}-${componentVersion}`;
  const oneTrustId = getConfig('cmp.onetrust_id') as string;

  useEffect(() => {
    window.onetrustId = oneTrustId;
  }, []);

  if (process.env.CONSENT_DISABLED === 'true') {
    return null;
  }

  return (
    <>
      {/* Consent Stub containing tcfapi */}
      <Script src="https://cdn.cookielaw.org/consent/tcf.stub.js" strategy="beforeInteractive" />

      {/* CMP - OneTrust consent */}
      <Script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        strategy="beforeInteractive"
        data-document-language="true"
        data-domain-script={`${oneTrustId}`}
      />

      {/* Lock bg-scroll for CMP banner */}
      <Script src={`${consentPath}/consent-conf.js?${cacheBuster}`} strategy="beforeInteractive" />

      {/* Aller consent library */}
      <Script src={`${consentPath}/consent-${consentVersion}.js`} strategy="beforeInteractive" />
    </>
  );
};

export default StandaloneConsent;
